import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../../design-system/icons.jsx';

export default function ColumnHeader({ col, sort, onSort, onFilterClick, filterActive }) {
  const { t } = useTranslation();
  const isSorted = sort?.col === col.key;
  const isAsc    = isSorted && sort.dir === 'asc';

  const sortIcon = isSorted
    ? (isAsc ? 'chevronUp' : 'chevronDown')
    : 'sort';

  return (
    <th style={col.headerStyle} aria-sort={col.sortable ? (isSorted ? (isAsc ? 'ascending' : 'descending') : 'none') : undefined}>
      <div className="d-inline-flex align-items-center gap-1">
        {col.sortable ? (
          <button type="button" onClick={() => onSort(col.key)} className="dt-col-header" style={{ background: 'none', border: 0, padding: 0, color: 'inherit', font: 'inherit' }}>
            {col.label}
            <Icon
              name={sortIcon}
              size={12}
              className={`dt-sort-icon${isSorted ? ' is-sorted' : ''}`}
            />
          </button>
        ) : (
          col.label
        )}

        {col.filterable && (
          <button
            type="button"
            aria-label={`${t('common.a11y.filter')} — ${col.label}`}
            aria-haspopup="dialog"
            style={{ background: 'none', border: 0, color: 'inherit' }}
            className={`dt-filter-icon${filterActive ? ' dt-filter-active' : ''}`}
            onClick={e => { e.stopPropagation(); onFilterClick(col.key, e.currentTarget); }}
            title={t('common.a11y.filter')}
          >
            <Icon name="filter" size={12} />
          </button>
        )}
      </div>
    </th>
  );
}
